import { render, staticRenderFns } from "./FormularioCtrlTecnicoComponent.vue?vue&type=template&id=b726c810"
import script from "./FormularioCtrlTecnicoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlTecnicoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports